import { Button as ButtonMaterial } from '@mui/material'
import styled, { css } from 'styled-components'
import { BREAKPOINT_SM } from '../../theme/ota'

export type ModalProps = {
  isOpen?: boolean
}

export type Double = {
  doubleInput?: 'left' | 'right'
}

export const Content = styled.div`
  width: 100%;

  @media (max-width: calc(${BREAKPOINT_SM})) {
    max-height: 100vh;
  }
`

export const IconInput = styled.div`
  position: relative;
`

export const Icon = styled.img<Double>`
  &&& {
    left: ${({ doubleInput }) => (doubleInput === 'right' ? '20px' : '8px')};
    height: 22px;
    pointer-events: none;
    position: absolute;
    top: 9px;
    user-select: none;
    width: 22px;
    z-index: 1;

    @media (max-width: calc(${BREAKPOINT_SM})) {
      top: 16px !important;
    }
  }
`

type InputCompleteProps = {
  doubleInput?: 'left' | 'right'
  noIcon?: boolean
  hasEndIcon?: boolean
}
export const InputComplete = styled.input<InputCompleteProps>`
  &&&& {
    transition: 0.15s ease-in-out;
    display: block;
    border: ${({ doubleInput, theme }) => (doubleInput ? 'none' : `1px solid ${theme?.colors?.gray4}`)};
    ${({ doubleInput, theme }) =>
      doubleInput === 'left'
        ? 'border-right: none;'
        : doubleInput === 'right'
        ? `border-left: 1px solid ${theme?.colors?.gray5};`
        : ''}
    border-radius: ${({ doubleInput }) =>
      doubleInput === 'left' ? '4px 0 0  4px' : doubleInput === 'right' ? '0 4px 4px 0' : '4px'};
    color: ${({ theme }) => theme?.colors?.text};
    flex: 1;
    font-size: 14px;
    height: 42px;
    overflow: hidden;
    margin: 0 20px 0 0;
    padding-left: ${({ doubleInput, noIcon }) => (noIcon ? '10px' : doubleInput === 'right' ? '44px' : '36px')};
    padding-right: ${({ doubleInput, noIcon, hasEndIcon }) =>
      noIcon && !hasEndIcon ? '10px' : hasEndIcon ? '25px' : doubleInput === 'left' ? '20px' : '10px'};
    position: relative;
    text-shadow: none;
    width: 100%;
    background-color: ${({ theme }) => theme?.colors?.white || '#ffffff'};

    @media (max-width: ${BREAKPOINT_SM}) {
      font-size: 16px !important;
      height: 52px !important;
    }

    &:disabled {
      background-color: #fafafa;
    }

    &.hasError {
      border-color: ${({ theme }) => theme?.colors?.error};
    }

    &:active,
    &:focus,
    &:hover {
      border: ${({ doubleInput, theme }) => (doubleInput ? 'none' : `1px solid ${theme?.colors?.gray5}`)};
      border: 1px solid ${({ theme }) => theme?.colors?.text};
    }
  }

  &:focus-visible {
    outline: none;
  }
`

export const Modal = styled.div`
  &&& {
    input {
      display: none !important;
    }

    button {
      display: none !important;
    }

    @media (max-width: calc(${BREAKPOINT_SM})) {
      background-color: ${({ theme }) => theme?.colors?.white} !important;
      display: block !important;
      height: 100vh !important;
      left: 0 !important;
      padding: 8px !important;
      position: relative !important;
      top: 0 !important;
      width: 100% !important;
      z-index: 1999 !important;

      input {
        border: 1px solid ${({ theme }) => theme?.colors?.gray5} !important;
        border-radius: 4px !important;
        color: ${({ theme }) => theme?.colors?.black} !important;
        display: block !important;
        flex: 1 !important;
        font-size: 14px !important;
        padding: 8px !important;
        position: relative !important;
        transition: 0.15s ease-in-out !important;
        width: 100% !important;
      }

      button {
        display: block !important;
      }
    }

    @media (max-width: calc(${BREAKPOINT_SM})) {
      font-size: 16px !important;
    }
  }
`

export const InputContainer = styled.div`
  &&& {
    padding: 0 10px 20px 20px;
    border-bottom: 1px solid ${({ theme }) => theme?.colors?.gray3};
  }
`

type ListDataProps = {
  width?: string
}

export const ListData = styled.div<ListDataProps>`
  &&& {
    ${({ width, maxHeight }) => css`
      border-radius: 5px !important;
      background-color: ${({ theme }) => theme?.colors?.white} !important;

      a {
        background-color: ${({ theme }) => theme?.colors?.white} !important;
        &.selected {
          background-color: ${({ theme }) => theme?.colors?.gray3} !important;
        }
        border: none !important;
        color: ${({ theme }) => theme?.colors?.text} !important;
        cursor: pointer !important;
        display: block !important;
        font-size: 14px !important;
        font-weight: 400 !important;
        line-height: 19px !important;
        &.withDefaultPaddingOption {
          padding: 10px !important;
        }
        text-align: left !important;
        text-decoration: none !important;
        text-shadow: none !important;
        transition: ease-in-out 0.2s !important;
        width: 100% !important;

        &:first-child {
          border-radius: 5px 5px 0 0 !important;
        }
        &:last-child {
          border-radius: 0 0 5px 5px !important;
        }
        & + a {
          position: relative;
          border-top: none !important;

          &::before {
            content: '';
            position: absolute;
            top: 0;
            left: 10px;
            right: 10px;
            height: 1px;
            background-color: ${({ theme }) => theme?.colors?.gray3};
          }

          @media (max-width: calc(${BREAKPOINT_SM})) {
            &::before {
              content: '';
              position: absolute;
              top: 0;
              left: 0;
              right: 0;
              height: 1px;
              background-color: ${({ theme }) => theme?.colors?.gray3};
            }
          }
        }

        &:hover {
          background-color: ${({ theme }) => theme?.colors?.gray1} !important;
          color: ${({ theme }) => theme?.colors?.textColor} !important;
        }
      }

      @media (min-width: calc(${BREAKPOINT_SM})) {
        max-height: 80vh;
        overflow-y: auto;
        width: ${width || '346px'} !important;
        &::-webkit-scrollbar {
          width: 15px; // Este width - a soma das bordas em webkit-scrollbar-thumb resulta na largura do scroll
        }

        &::-webkit-scrollbar-track-piece {
          background-color: transparent;
          border-color: #ffffff;
          border-width: 2px;
          border-style: solid;
        }

        &::-webkit-scrollbar-thumb {
          border-radius: 10px;
          background-color: #c5c5c5;
          border: 5px solid transparent; // cria o espaço lateral (entre o scroll)
          background-clip: padding-box;
        }
      }

      @media (max-width: calc(${BREAKPOINT_SM})) {
        border: none !important;
        box-shadow: none !important;
        width: 100% !important;
      }
    `}
  }
`

export const NotFound = styled.div`
  &&& {
    height: 60px !important;
    padding: 6px !important;
    width: 100% !important;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    p {
      font-size: 12px !important;
      margin: 0 !important;
    }

    @media (max-width: 500px) {
      height: 54px !important;
      padding: 4px 8px !important;
    }
  }
`

export const Button = styled(ButtonMaterial)`
  padding: 8px !important;
`

type EndIconProps = {
  rotateIconWhenOpen?: boolean
}

export const EndIcon = styled.div<EndIconProps>`
  &&& {
    display: flex;
    align-items: center;
    justify-content: center;
    pointer-events: none;
    position: absolute;
    top: 10px;
    right: 10px;
    user-select: none;
    z-index: 1;
    transform: ${({ rotateIconWhenOpen }) => (rotateIconWhenOpen ? 'rotate(180deg)' : 'unset')};

    @media (max-width: calc(${BREAKPOINT_SM})) {
      top: 16px !important;
    }
  }
`
